import { useMutation, useQuery } from 'react-query';
import { getSurvey, getSurveyType, getSurveyUser, saveAnswer } from '@/api/survey';
import { useLocale } from '@/hooks/translation';
import { isFeatureEnabled } from '@separate/utilities/features';

export function useSurveyFetch({ onSuccess, onError }) {
  const { isIdle, isLoading, mutate } = useMutation(
    getSurvey,
    {
      onSuccess,
      onError,
      useErrorBoundary: ({ response }) => response?.status !== 404,
    }
  );
  return { isIdle, isLoading, fetchSurvey: mutate };
}

export function useSurveyUserFetch({ onSuccess, onError }) {
  const { isLoading, mutate } = useMutation(
    getSurveyUser,
    {
      onSuccess,
      onError,
    }
  );
  return { isLoading, fetchSurveyUser: mutate };
}

const BAD_ANSWER_STATUS = 'bad_answer';

export function useSaveAnswer({ onSuccess, onError }) {
  const locale = useLocale();

  function handleSuccess(result) {
    if (result?.status && result?.status !== BAD_ANSWER_STATUS && (result?.next_question_id || result?.progress)) {
      onSuccess(result);
    } else {
      onError(result);
    }
  }
  const { isLoading, mutate } = useMutation(
    (props) => saveAnswer({ locale, ...props }),
    {
      onSuccess: handleSuccess,
      onError
    }
  );
  return { isLoading, saveAnswer: mutate };
};

export function useGetSurveyType({ id, employeeToken }) {
  const insightsEnabled = isFeatureEnabled('insights');

  const result = useQuery({
    queryKey: ['survey-type', id],
    queryFn: () => getSurveyType({ id, employeeToken }),
    retry: insightsEnabled ? undefined : false,
    useErrorBoundary: insightsEnabled ? true : ({ response }) => response && response.status !== 404,
  });

  const { isLoading, data } = result;
  return { isLoading, data };
}
